module.exports = __webpack_public_path__ + "media/5.c2d9b48b.mp3";